import {
  CURRENCY_SAVE_CURRENCY_BEGIN,
  CURRENCY_SAVE_CURRENCY_SUCCESS,
  CURRENCY_SAVE_CURRENCY_FAILURE,
  CURRENCY_SAVE_CURRENCY_DISMISS_ERROR,
} from './constants';
import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveCurrency(currency, action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CURRENCY_SAVE_CURRENCY_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/currencies';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        currency.currency = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        currency:currency
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: CURRENCY_SAVE_CURRENCY_SUCCESS,
              data: res,
              action_model:action
            });
            resolve(res);
          }else
          {
            dispatch({
            type: CURRENCY_SAVE_CURRENCY_FAILURE,
            data: { error: "Internal Error" },
            action_model:action
          });
          reject("Internal Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CURRENCY_SAVE_CURRENCY_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveCurrencyError() {
  return {
    type: CURRENCY_SAVE_CURRENCY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CURRENCY_SAVE_CURRENCY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveCurrencyPending: true,
        saveCurrencyError: null,
      };

    case CURRENCY_SAVE_CURRENCY_SUCCESS:
      let fragmentContent = "The currency has been updated with success!";
      let fragmentTitle = "Update Currency";
      let paperTitle = "Update Currency";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The currency has been created with success!'
        fragmentTitle='Create Currency'
        paperTitle='Create Currency'
      }
      // The request is success
      return {
        ...state,
        saveCurrencyPending: false,
        saveCurrencyError: null,
        savePending:false,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
      };

    case CURRENCY_SAVE_CURRENCY_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Update Currency";
      let paperTitleFail = "Update Currency";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The currency has not been created with success!'
        fragmentTitleFail='Create Currency'
        paperTitleFail='Create Currency'
      }
      return {
        ...state,
        saveCurrencyPending: false,
        saveCurrencyError: action.data.error,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
      };

    case CURRENCY_SAVE_CURRENCY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveCurrencyError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/currency/redux/saveCurrency.js